<template>
  <div class="tw-flex tw-items-center tw-gap-2">
    <span class="tw-block tw-text-md tw-font-medium">{{ label }}</span>

    <c-badge v-if="badge">{{ badge }}</c-badge>

    <c-tooltip-standalone v-if="tooltip" size="xs"
      >{{ tooltip }}
    </c-tooltip-standalone>
  </div>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    required: true,
  },
  tooltip: {
    type: [String, null],
    default: () => "",
  },
  badge: {
    type: [String, null],
    default: () => null,
  },
});
</script>
